import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from "react-router-dom";
import Cookies from 'universal-cookie';
import './Modal.scss';
import Modal from 'react-modal';
import { IconClose } from '../../assets/svgs-index';
import { TermsLabels } from '../../assets/labels/labels';
import { CompanyService } from '../../core/services/company.service';
import { AuthenticationService } from '../../core/services/authentication.service';

interface ModalRegisterProps {
  modalIsOpen: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  showClose?: boolean;
  replaceCompanyName?: string;
  replaceVat?: string;
  replaceClient?: string;
  replaceItem?: string;
  replaceWork?: string;
  replaceCompanies?: string;
  companyTerms?: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ModalIAgree = (props: ModalRegisterProps) => {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [title] = useState(TermsLabels.privacy.generalTitle);
  const [message, setMessage] = useState(TermsLabels.privacy.message1);
  const [confirmText] = useState<string>("Continuar");
  const [showClose] = useState<boolean>(true);
  const [replaceCompanyName, setReplaceCompanyName] = useState<string>("");
  const [replaceVat, setReplaceVat] = useState<string>("");
  const [replaceClient, setReplaceClient] = useState<string>("");
  const [replaceItem, setReplaceItem] = useState<string>("");
  const [replaceWork, setReplaceWork] = useState<string>("");
  const [replaceCompanies, setReplaceCompanies] = useState<string>("");
  const [companyTerms, setCompanyTerms] = useState<string>("");
  const [termsTitle] = useState(TermsLabels.privacy.termsTitle);
  const location = useLocation();
  const cookies = useMemo(() => new Cookies(), []);
  const [domain, setDomain] = useState<string>(location?.state?.domain || cookies.get("kssreturncompany")?.replace(".qa", "") || "");



  useEffect(() => {
    (async () => {
      try {
        const companiesData = await CompanyService.fetchCompanies();
        const companiesString = companiesData
          .map(company => company.name ? company.name : company.domain)
          .join(", ");
        setReplaceCompanies(companiesString);
      } catch (error) {
        console.error("Error fetching companies: ", error);
      }
    })();
  }, []);


  useEffect(() => {
    const timer = setTimeout(() => {
      setModalIsOpen(props.modalIsOpen);
    }, 200);
    if (props.modalIsOpen) {
      setDomain(location?.state?.domain || cookies.get("kssreturncompany")?.replace(".qa", "") || "");
    }
    return () => clearTimeout(timer);
  }, [props.modalIsOpen, cookies, location]);


  useEffect(() => {
    if (domain) {
      setCompanyIAgreeData(domain);
    }
  }, [domain]);

  useEffect(() => {   
    setMessage(replaceVariables(TermsLabels.privacy.message1, replaceCompanyName ?? "", replaceVat ?? "", replaceClient ?? "", replaceItem ?? "", replaceWork ?? "", replaceCompanies ?? ""));
  }, [replaceCompanyName, replaceVat, replaceClient, replaceItem, replaceWork, replaceCompanies]);

  const closeModal = () => {
    props.onClose();
  };

  const setCompanyIAgreeData = (domain: string) => {
    if (!domain) return;
    AuthenticationService.serviceGetCompanyIAgreeData(domain).then((res) => {
      if (res) {
        if (res.client && res.client.length > 0) {
          const clientString = res.client.join(', ');
          setReplaceClient(clientString);
        }
        if (res.item && res.item.length > 0) {
          let itemString = res.item.join(', ');
          if (res.client) itemString= ', '+ itemString;
          setReplaceItem(itemString);
        }
        if (res.work && res.work.length > 0) {
          let workString = res.work.join(', ');
          if (res.item || res.client) workString= ', '+ workString;
          setReplaceWork(workString);
        }
        if (res.vat) {
          setReplaceVat(res.vat);
        }
        if (res.name || domain) {
          setReplaceCompanyName(res.name || domain);
        }
        if (res.terms) {
          setCompanyTerms(res.terms);
        }
      }
    }).catch((error: Error) => {
      console.error("Error fetching company data: ", error.message);
    });
  }

  const renderCTAContainer = () => {
    return (
      <div className="cta-button-primary d-medium mt-4" role="button" onClick={props.onConfirm}>
        {confirmText}
      </div>
    );
  }

  const replaceVariables = (
    message: string,
    replaceCompanyName: string,
    replaceVat: string,
    replaceClient: string,
    replaceItem: string,
    replaceWork: string,
    replaceCompanies: string
  ) => {
    if (replaceCompanyName === "" && replaceVat === "") {
      replaceCompanyName = "Acordo Certo 2, Unipessoal Lda";
      replaceVat = "509 888 925";
      message = message.replace(
        "Consulte aqui os dados que poderemos recolher por conta da Empresa: *client**item**work* \n",
        ""
      );
    }
    if (replaceVat === "") {
      message = message.replace(
        " (NIPC *vat*)",
        ""
      );
    }
    return message
      .replace(/\*companyname\*/g, replaceCompanyName)
      .replace(/\*vat\*/g, replaceVat)
      .replace(/\*client\*/g, replaceClient)
      .replace(/\*item\*/g, replaceItem)
      .replace(/\*work\*/g, replaceWork + '.')
      .replace(/\*companies\*/g, replaceCompanies);
  };

  const renderTextWithBold = (text: string): JSX.Element[] => {
    // Split text into segments with regular and bold text
    const segments = text.split(/(\*\*.*?\*\*)/).filter(Boolean);
    return segments.map((segment, index) => {
      if (/^\*\*(.*?)\*\*$/.test(segment)) {
        // Remove the bold markers and return the text in bold
        return <strong key={index}>{segment.slice(2, -2)}</strong>;
      } else {
        // Return the text as is, wrapped in a span for React key
        return <span key={index}>{segment}</span>;
      }
    });
  };

  return (
    <>
      {modalIsOpen && (
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          shouldCloseOnOverlayClick={showClose}
          style={{
            content: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingRight: '0px',
              padding: '0px',
              top: '0px',
              position: 'relative',
              maxHeight: '85%'

            },
          }}
        >
          {showClose && (
            <div
              className="icon-close"
              role="button"
              onClick={closeModal}
              style={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                zIndex: '999',
              }}
            >
              <img src={IconClose} alt="icon-modal-close" />
            </div>
          )}
          <div className="modal-content-container d-flex flex-column align-center" style={{ position: 'relative' }}>
            <h2 className="m-0 p-0 text-center mb-3">{title}</h2>
            <p className="light mt-1 mx-0 mx-sm-0" style={{ textAlign: 'justify' }}>
              {message?.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {renderTextWithBold(line)}
                  {index !== message.split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </p>
            <p className="light text-center mt-1 mx-3 mx-sm-6"></p>
            {companyTerms && <>
              <h2 className="m-0 p-0 text-center mb-3">{termsTitle}</h2>
              <p className="light mt-1 mx-0 mx-sm-0" style={{ textAlign: 'justify' }}>
                {companyTerms}
              </p>
            </>
            }
          </div>
          {renderCTAContainer()}
        </Modal>
      )}
    </>
  );
}

export default ModalIAgree;